import { I18nextProvider } from 'react-i18next';
import { initI18n } from '@/lib/i18n';

interface I18nProviderProps {
  children: React.ReactNode;
}

const i18nInstance = initI18n();

export function I18nProvider({ children }: I18nProviderProps) {
  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
